<template>
  <div>
    <v-card>
      <v-card-text>
      <v-form class="mt-5">

        <v-text-field
          v-validate="'required|max:255'"
          v-model="shippingMethod.name"
          :error-messages="errors.collect('name')"
          :class="inputClass('name')"
          label="Name"
          data-vv-name="name"
          required
        ></v-text-field>

        <v-text-field
          v-validate="'required|max:255'"
          v-model="shippingMethod.extId"
          :error-messages="errors.collect('extId')"
          :class="inputClass('extId')"
          label="External ID"
          data-vv-name="extId"
          required
        ></v-text-field>

        <v-autocomplete
          v-model="shippingMethod.shippingMethodId"
          :items="shippingMethods"

          :class="inputClass('sm')"
          color="white"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="id"
          label=""
          placeholder="Shipping Method"


        ></v-autocomplete>

        <v-card-actions class="pr-0">
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="submit"
                 :loading="loading"
                 :disabled="loading"
          >
            Save
            <v-icon right dark>done</v-icon>
          </v-btn>
          <v-btn
                 color="secondary" @click="cancel"
                 :loading="loading"
                 :disabled="loading"
          >
            Cancel
            <v-icon right dark>cancel</v-icon>
          </v-btn>
        </v-card-actions>

      </v-form>
      </v-card-text>
      </v-card>
    </div>
</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';

export default {

  name: 'MPayShippingMethodEditor',

  props: {
    loading: { type: Boolean, required: false, default: false },
    shippingMethod: { type: Object, required: true },
  },

  components: { },

  data: () => ({

    editableProperties: [
      'name',
      'extId',
    ],
    editableRules: [
      'required',
      'required',
    ],
    shippingMethods: [],
    isLoading: false,
  }),

  computed: {
    merchantId() {
      return this.$route.query.merchant;
    },
    beanPropertyValues() {
      return {
        total_currency: [
          'EUR',
        ],
        type: [
          'CHECKOUT',
          'INSTANT',
        ],
      };
    },
  },

  methods: {
    submit() {
      const model = Object.assign({}, this.shippingMethod);
      this.$emit('submit', model);
    },
    cancel() {
      this.$emit('cancel');
    },
    inputClass(name) {
      if (this.fields[name]) {
        const changed = this.fields[name].changed;
        return { 'merchants-editor__input__not-changed': !changed };
      }
      return {};
    },
    fetchShippingMethods() {
      this.loading = true;
      axios.get(queries.shippingMethods())
        .then((response) => {
          this.shippingMethods = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
  },
  created() {
    this.fetchShippingMethods();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/merchant/MPayShippingMethodEditor.vue